import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { FullWidthLayout } from "@/layouts";
import { TitleContainer, SectionTitle } from "../home.styles";
import { ButtonMui } from "@/components/ui";
import * as Styled from "./helpSection.styles";

const HelpSection: FC = () => {
  const { t } = useTranslation("global");
  return (
    <FullWidthLayout
      id="help"
      bgColor="var(--inverse-on-surface-light)"
    >
      <Styled.MainScreenContainer>
        <Styled.TextContaoner>
          <TitleContainer
            display="flex"
            jContent="center"
            aItem="center"
            fDirection="column"
          >
            <SectionTitle
              className="display-large"
              color={"var(--on-surface-light)"}
            >
              {t("help.title")}
            </SectionTitle>
            <SectionTitle
              pd="1.25rem 0 0"
              className="body-large"
              color={"var(--surface-dark)"}
            >
              {t("help.description")}
            </SectionTitle>
          </TitleContainer>
        </Styled.TextContaoner>
        <Styled.HelpButtons>
          <ButtonMui
            size="medium"
            color="primary"
            variant="contained"
            endIcon={<ArrowForwardIcon width={1} />}
          >
            <Link href="/freetrial">{t("help.button")}</Link>
          </ButtonMui>

          <ButtonMui size="medium" variant="text" color="primary">
            <Link href="/contact">{t("help.contact")}</Link>
          </ButtonMui>
        </Styled.HelpButtons>
      </Styled.MainScreenContainer>
    </FullWidthLayout>
  );
};
export default HelpSection;
